import React, { useEffect, useRef, useState } from "react";
import NotFound from "../../../components/not-found/NotFound";
import ViewListRoundedIcon from "@mui/icons-material/ViewListRounded";
import { toastMessage } from "../../../utils/toastMessage";
import { useSearchParams } from "react-router-dom";
import { getConsultantOrderHistoryApi, refundConsultationApi } from "../../../services/consultantManagement";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import Pagination from "react-js-pagination";
import { dateFormatWithTime, formatDuration } from "../../../utils/dateFormat";
import { IconButton, Paper, useScrollTrigger, Modal, Box, Typography, List, ListItem, ListItemText, Chip } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import HistoryIcon from "@mui/icons-material/History";
import { Link, useParams } from "react-router-dom";
import AddNotification from "../../notificationManagement/AddNotification";
import { FaPlay, FaPause } from 'react-icons/fa';
import axios from "axios";
import { initiateSocketConnection } from "../../../utils/common";
import constants from "../../../utils/constants";
import { FREE_COUPON_CODE } from "../../../utils/freeCoupon";
import ChatBox from "../../../components/chatBox/ChatBox";
import ModalBox from "../../../components/modal/ModalBox";
import { Input, TextArea } from "../../../components/Form";
import useButtonLoader from "../../../hooks/UseButtonLoader";
const _CURRENT_USER = {
  _id: '000000000000000000000000',
  name: 'Vedicmeet Admin',
  profileImage: 'https://vedicmeet.com/statics/vedic-meet_title-logo.webp'
};

const getUniqueConsultationLogs = (logs = []) => {
  const seen = new Set();
  return logs.filter((log) => {
    const key = [
      log.callStatus || '',
      log.callBy || '',
      log.callEndedBy || '',
      log.actionBy || '',
      log.actionValue || '',
      log.cancelledBy || '',
    ].join('|');

    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

const getConsultationRecordingUrl = (consultation = {}) => (
  consultation?.recordingUrl ||
  consultation?.recording_url ||
  consultation?.callRecordingUrl ||
  consultation?.onCompletion?.recordingUrl ||
  consultation?.onCompletion?.recording_url ||
  consultation?.onCompletion?.callRecordingUrl ||
  consultation?.session_info?.recordingUrl ||
  consultation?.session_info?.recording_url ||
  consultation?.session_info?.callRecordingUrl ||
  consultation?.session_info?.sessionMeta?.recordingUrl ||
  consultation?.session_info?.sessionMeta?.recording_url ||
  ""
);

const ConsultantHistory = ({
  handlePageChange,
  total,
  activePage,
  orderList,
  pageLimit = 10,
  consultantId,
  onConsultationHistoryRefresh
}) => {
  const [openModalIndex, setOpenModalIndex] = useState(null);
  const [updatedQueryStatusModal, setUpdateQueryStatusModal] = useState(false);
  const [showLogModal, setShowLogModal] = useState(false);
  const [selectedLogs, setSelectedLogs] = useState([]);

  const [showChatBox, setShowChatBox] = useState(false);
  const [selectedThreadId, setSelectedThreadId] = useState(null);
  const [selectedUserName, setSelectedUserName] = useState("");
  const [userId, setUserId] = useState(null);
  const [selectedRecordingUrl, setSelectedRecordingUrl] = useState("");
  const [selectedOrderId, setSelectedOrderId] = useState("");
  const [selectedConsultationMode, setSelectedConsultationMode] = useState("");

  // Refund modal states
  const [refundModal, setRefundModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [userRefundAmount, setUserRefundAmount] = useState('');
  const [consultantDeductionAmount, setConsultantDeductionAmount] = useState('');
  const [userMessage, setUserMessage] = useState('');
  const [consultantMessage, setConsultantMessage] = useState('');
 
  const [refundErrors, setRefundErrors] = useState({});
  const [buttonref, buttonLoader] = useButtonLoader("Process Refund");

  const formatDuration = (ms) => {
    const totalSeconds = Math.floor(ms / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    return `${minutes}m ${seconds}s`;
  };

  const formatTimestamp = (timestamp) => {
    return new Date(timestamp).toLocaleString();
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'initiated':
        return 'primary';
      case 'started':
        return 'success';
      case 'ended':
        return 'error';
      case 'session_extended':
        return 'warning';
      default:
        return 'default';
    }
  };

  const handleShowLogs = (logs) => {
    const uniqueLogs = getUniqueConsultationLogs(logs);
    if (uniqueLogs && uniqueLogs.length > 0) {
      setSelectedLogs(uniqueLogs);
      setShowLogModal(true);
    } else {
      toastMessage('No logs available for this consultation', 'info');
    }
  };

  // Refund handlers
  const handleRefundClick = (order) => {
    setSelectedOrder(order);
    if(order?.onCompletion?.baseAmount === order?.onCompletion?.refundDetail?.refundAmount){
      toastMessage('Refund amount is already refunded', 'error');
      return;
    }
    let userRefundAmount = order?.onCompletion?.baseAmount
    if(order?.onCompletion?.refundDetail?.refundAmount){
      userRefundAmount = order?.onCompletion?.baseAmount - order?.onCompletion?.refundDetail?.refundAmount;
    } 
    let consultantDeductionAmount = order?.onCompletion?.consultantAmount
    if(order?.onCompletion?.refundDetail?.consultantDeductionAmount){
      consultantDeductionAmount = order?.onCompletion?.consultantAmount - order?.onCompletion?.refundDetail?.consultantDeductionAmount;
    }
    setUserRefundAmount(userRefundAmount?.toString() || '');
    setConsultantDeductionAmount(consultantDeductionAmount?.toString() || '');
    setUserMessage('');
    setConsultantMessage('');
    setRefundErrors({});
    setRefundModal(true);
  };

  const handleUserRefundChange = (e) => {
    const value = e.target.value;
    setUserRefundAmount(value);
    
    // Clear error when user starts typing
    if (refundErrors.userRefundAmount) {
      setRefundErrors(prev => ({ ...prev, userRefundAmount: '' }));
    }
  };

  const handleConsultantDeductionChange = (e) => {
    const value = e.target.value;
    setConsultantDeductionAmount(value);
    
    // Clear error when user starts typing
    if (refundErrors.consultantDeductionAmount) {
      setRefundErrors(prev => ({ ...prev, consultantDeductionAmount: '' }));
    }
  };


  const validateRefundData = () => {
    const errors = {};
    
    const userAmount = parseFloat(userRefundAmount);
    const consultantAmount = parseFloat(consultantDeductionAmount);
    
    if (!userRefundAmount || isNaN(userAmount) || userAmount <= 0) {
      errors.userRefundAmount = 'User refund amount is required and must be greater than 0';
    }
    
    if (!consultantDeductionAmount || isNaN(consultantAmount) || consultantAmount < 0) {
      errors.consultantDeductionAmount = 'Consultant deduction amount is required and must be 0 or greater';
    }

    setRefundErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleRefundSubmit = async () => {
    if (!validateRefundData()) {
      return;
    }

    const resetAndCloseRefundModal = () => {
      setRefundModal(false);
      setUserRefundAmount('');
      setConsultantDeductionAmount('');
      setUserMessage('');
      setConsultantMessage('');
      setRefundErrors({});
      setSelectedOrder(null);
    };

    try {
      buttonLoader(true);
      
      const refundPayload = {
        waitlistId: selectedOrder._id,
        consultantId: consultantId,
        userRefundAmount: parseFloat(userRefundAmount),
        consultantDeductionAmount: parseFloat(consultantDeductionAmount),
        userMessage: userMessage,
        consultantMessage:consultantMessage
      };

      const response = await refundConsultationApi(refundPayload);
      const { code, message } = response?.data || {};

      if (code === 200) {
        toastMessage(message || 'Refund processed successfully', 'success');
        resetAndCloseRefundModal();
        await onConsultationHistoryRefresh?.();
      } else {
        toastMessage(message || 'Failed to process refund', 'error');
      }
    } catch (error) {
      console.error('Refund error:', error);
      const apiMessage =
        error?.response?.data?.message ||
        error?.message ||
        '';

      toastMessage(apiMessage || 'Failed to process refund', 'error');
    } finally {
      buttonLoader(false);
    }
  
  };

  const LogModal = ({ open, onClose, logs }) => {
    return (
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="log-modal-title"
        aria-describedby="log-modal-description"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 600,
          maxHeight: '80vh',
          bgcolor: '#fafafa',
          border: '1px solid #e0e0e0',
          borderRadius: '8px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
          p: 4,
          overflow: 'auto'
        }}>
          <Typography id="log-modal-title" variant="h6" component="h2" gutterBottom sx={{ color: '#333', fontWeight: 600 }}>
            Consultation Logs
          </Typography>
          <Typography id="log-modal-description" variant="body2" color="text.secondary" gutterBottom sx={{ color: '#666' }}>
            Detailed timeline of consultation events
          </Typography>
          
          <List>
            {logs.map((log, index) => (
              <ListItem key={index} sx={{ 
                border: '1px solid #f0f0f0', 
                mb: 1, 
                borderRadius: 2,
                backgroundColor: '#ffffff',
                '&:hover': {
                  backgroundColor: '#f8f9fa',
                  borderColor: '#e9ecef'
                }
              }}>
                <ListItemText
                  primary={
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Chip 
                        label={log.callStatus} 
                        color={getStatusColor(log.callStatus)}
                        size="small"
                        sx={{ 
                          backgroundColor: getStatusColor(log.callStatus) === 'primary' ? '#e3f2fd' : 
                                         getStatusColor(log.callStatus) === 'success' ? '#e8f5e8' :
                                         getStatusColor(log.callStatus) === 'error' ? '#ffebee' :
                                         getStatusColor(log.callStatus) === 'warning' ? '#fff3e0' : '#f5f5f5',
                          color: getStatusColor(log.callStatus) === 'primary' ? '#1976d2' : 
                                 getStatusColor(log.callStatus) === 'success' ? '#2e7d32' :
                                 getStatusColor(log.callStatus) === 'error' ? '#d32f2f' :
                                 getStatusColor(log.callStatus) === 'warning' ? '#ed6c02' : '#666'
                        }}
                      />
                      {log.callBy && (
                        <Typography variant="body2" sx={{ color: '#666' }}>
                          by {log.callBy}
                        </Typography>
                      )}
                      {log.callEndedBy && (
                        <Typography variant="body2" sx={{ color: '#666' }}>
                          ended by {log.callEndedBy}
                        </Typography>
                      )}
                      {log.callStatus  == 'missed' ? (
                        <Typography variant="body2" sx={{ color: '#666' }}>
                          by {log.actionBy == 'both' ? 'Both' : log.actionBy == consultantId ? 'Consultant' : 'User'}
                          {log.actionBy}
                        </Typography>
                      ) : log.callStatus == 'cancelled' ? (
                        <Typography variant="body2" sx={{ color: '#666' }}>
                          by {log.cancelledBy ? log.cancelledBy : log.callBy}
                        </Typography>
                      ) : (
                        <Typography variant="body2" sx={{ color: '#666' }}>
                          {log.actionBy}
                        </Typography>
                      )}
                      {log.actionValue && (
                        <Typography variant="body2" sx={{ color: '#666' }}>
                          ({log.actionValue}s)
                        </Typography>
                      )}
                    </Box>
                  }
                  secondary={
                    <Typography variant="body2" sx={{ color: '#888', fontSize: '0.875rem' }}>
                      {formatTimestamp(log.timestamp)}
                    </Typography>
                  }
                />
              </ListItem>
            ))}
          </List>
          
          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
            <IconButton 
              onClick={onClose} 
              sx={{ 
                backgroundColor: '#f0f0f0',
                '&:hover': {
                  backgroundColor: '#e0e0e0'
                }
              }}
            >
              Close
            </IconButton>
          </Box>
        </Box>
      </Modal>
    );
  };

  // Refund Modal Component

    
    
   

  return (
    <>
      {showChatBox && (
        <ChatBox
          threadId={selectedThreadId}
          userName={selectedUserName}
          userId={userId}
          isConsultant={true}
          onClose={() => {
            setShowChatBox(false);
            setSelectedThreadId(null);
            setSelectedRecordingUrl("");
            setSelectedOrderId("");
            setSelectedConsultationMode("");
          }}
          recordingUrl={selectedRecordingUrl}
          orderId={selectedOrderId}
          consultationMode={selectedConsultationMode}
        />
      )}

      <LogModal
        open={showLogModal}
        onClose={() => setShowLogModal(false)}
        logs={selectedLogs}
      />
<ModalBox
        status={refundModal}
        onClose={() => {
          setRefundModal(false);
          setUserRefundAmount('');
          setConsultantDeductionAmount('');
          setUserMessage('');
          setConsultantMessage('');
          setRefundErrors({});
          setSelectedOrder(null);
        }}
        title="💰 Refund Consultation"
        closeIcon
        size="lg"
        custom
        customizedFooter={
          <div className="model_custom_footer" style={{ 
            display: 'flex', 
            justifyContent: 'flex-end', 
            gap: '10px',
            padding: '15px 0',
            borderTop: '1px solid #e9ecef'
          }}>
            <button
              className="btn_size"
              onClick={() => setRefundModal(false)}
              style={{
                backgroundColor: '#6c757d',
                color: 'white',
                border: 'none',
                padding: '8px 20px',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: '500'
              }}
            >
              ❌ Cancel
            </button>
            <button
              className="btn_size"
              ref={buttonref}
              onClick={handleRefundSubmit}
              style={{
                backgroundColor: '#ffc107',
                color: '#212529',
                border: 'none',
                padding: '8px 20px',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: '600'
              }}
            >
              💰 Process Refund
            </button>
          </div>
        }
      >
        <div>
          {/* Consultation Details Section */}
          <div className="consultation-details-section" style={{ 
            backgroundColor: '#f8f9fa', 
            padding: '15px', 
            borderRadius: '8px', 
            marginBottom: '20px',
            border: '1px solid #e9ecef'
          }}>
            <h6 style={{ 
              color: '#495057', 
              marginBottom: '15px', 
              fontSize: '16px',
              fontWeight: '600',
              borderBottom: '2px solid #007bff',
              paddingBottom: '8px'
            }}>
              📋 Consultation Details
            </h6>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
              <div>
                <p style={{ margin: '5px 0', fontSize: '14px' }}>
                  <strong style={{ color: '#495057' }}>👤 User:</strong> 
                  <span style={{ color: '#6c757d', marginLeft: '5px' }}>
                    {selectedOrder?.request_form?.firstName} {selectedOrder?.request_form?.lastName}
                  </span>
                </p>
                <p style={{ margin: '5px 0', fontSize: '14px' }}>
                  <strong style={{ color: '#495057' }}>📅 Date:</strong> 
                  <span style={{ color: '#6c757d', marginLeft: '5px' }}>
                    {dateFormatWithTime(selectedOrder?.createdAt)}
                  </span>
                </p>
                <p style={{ margin: '5px 0', fontSize: '14px' }}>
                  <strong style={{ color: '#495057' }}>💰 Original Amount:</strong> 
                  <span style={{ color: '#28a745', marginLeft: '5px', fontWeight: '600' }}>
                    ₹{selectedOrder?.onCompletion?.amountToDeduct?.toFixed(2) || '0.00'}
                  </span>
                </p>
              </div>
              <div>
                <p style={{ margin: '5px 0', fontSize: '14px' }}>
                  <strong style={{ color: '#495057' }}>🎯 Consultant:</strong> 
                  <span style={{ color: '#6c757d', marginLeft: '5px' }}>
                    {selectedOrder?.consultantDetail?.accountName}
                  </span>
                </p>
                <p style={{ margin: '5px 0', fontSize: '14px' }}>
                  <strong style={{ color: '#495057' }}>💵 Consultant Earnings:</strong> 
                  <span style={{ color: '#17a2b8', marginLeft: '5px', fontWeight: '600' }}>
                    ₹{selectedOrder?.onCompletion?.consultantAmount?.toFixed(2) || '0.00'}
                  </span>
                </p>
              </div>
            </div>

            {/* Refund Details Section */}
            <div>
                <p style={{ margin: '5px 0', fontSize: '14px' }}>
                  <strong style={{ color: '#495057' }}>💸 Refund Amount:</strong> 
                  <span style={{ color: '#17a2b8', marginLeft: '5px', fontWeight: '600' }}>
                    ₹{selectedOrder?.onCompletion?.refundDetail?.refundAmount?.toFixed(2) || '0.00'}
                  </span>
                </p>
              </div>
              <div>
                <p style={{ margin: '5px 0', fontSize: '14px' }}>
                  <strong style={{ color: '#495057' }}>💸 Consultant Deduction Amount:</strong> 
                  <span style={{ color: '#17a2b8', marginLeft: '5px', fontWeight: '600' }}>
                    ₹{selectedOrder?.onCompletion?.refundDetail?.consultantDeductionAmount?.toFixed(2) || '0.00'}
                  </span>
                </p>
              </div>
             
            </div>
           

          {/* Refund Amounts Section */}
          <div className="refund-amounts-section" style={{ marginBottom: '20px' }}>
            <h6 style={{ 
              color: '#495057', 
              marginBottom: '15px', 
              fontSize: '16px',
              fontWeight: '600',
              borderBottom: '2px solid #ffc107',
              paddingBottom: '8px'
            }}>
              💸 Refund Amounts
            </h6>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
              <div className="form-group mb-2">
                <Input
                  type="text"
                  name="userRefundAmount"
                  value={userRefundAmount}
                  required
                  onChange={handleUserRefundChange}
                  placeholder="Enter refund amount for user"
                  className="form-control"
                  label="User Refund Amount (₹)"
                  error={refundErrors.userRefundAmount}
                  pattern="[0-9]*\.?[0-9]*"
                  inputMode="decimal"
                />
              </div>
              
              <div className="form-group mb-2">
                <Input
                  type="text"
                  name="consultantDeductionAmount"
                  value={consultantDeductionAmount}
                  required
                  onChange={handleConsultantDeductionChange}
                  placeholder="Enter deduction amount for consultant"
                  className="form-control"
                  label="Consultant Deduction Amount (₹)"
                  error={refundErrors.consultantDeductionAmount}
                />
              </div>
            </div>
          </div>
          
          {/* Messages Section */}
          <div className="messages-section">
            <h6 style={{ 
              color: '#495057', 
              marginBottom: '15px', 
              fontSize: '16px',
              fontWeight: '600',
              borderBottom: '2px solid #6f42c1',
              paddingBottom: '8px'
            }}>
              💬 Messages (Optional)
            </h6>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
              <div className="form-group mb-2">
                <TextArea
                  name="userMessage"
                  value={userMessage}
                  onChange={(e) => setUserMessage(e.target.value)}
                  placeholder="Message for user (optional)"
                  className="form-control"
                  label="User Message"
                  rows={3}
                />
              </div>
              
              <div className="form-group mb-2">
                <TextArea
                  name="consultantMessage"
                  value={consultantMessage}
                  onChange={(e) => setConsultantMessage(e.target.value)}
                  placeholder="Message for consultant (optional)"
                  className="form-control"
                  label="Consultant Message"
                  rows={3}
                />
              </div>
            </div>
          </div>
        </div>
      </ModalBox>
      

      <div className="content-table" >
        <div style={{ overflow: 'auto', flex: '1 1 0', minHeight: '460px' }}>
        <table>
          <thead>
            <tr>
              <th>S. No.</th>
              <th>User Id </th>
              <th>User Name</th>
              <th>User Gender</th>
              <th>Type of Consultantation</th>
              <th>Mode of Consultation</th>
              <th>Consultant Name</th>
              <th>Date and Time</th>
              <th>Duration</th>
              <th>User’s Problem</th>
             
              <th>User Total Consultations</th>
              <th>Consultation</th>
              <th>Consultant's Earnings</th>
              <th>query</th>
              
               {/* <th>Company Earning</th> */}
                     {/* <th>User Deduction</th> */}
              <th>Refund Details</th>
              <th>Chat History</th>
              <th>Log Entries</th>
              <th>Refund Action</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {orderList.length > 0 ? (
              orderList.map((order, index) => (
                <tr key={index}>
                  <td>{(activePage - 1) * pageLimit + index + 1}</td>
                  <td>{order?.userDetail?.userId || "---"}</td>
                  <td>{`${order?.request_form?.firstName || order?.userDetail?.name || ''}`.trim() || "---"}</td>
                  <td>{order?.request_form?.gender || "---"}</td>
                  <td>{order?.session_info?.mode || "---"}</td>
                  <td>{FREE_COUPON_CODE.includes(order?.coupon?.code) ? 'Free' : 'Paid'}</td>
                  <td>{order?.consultantDetail?.accountName || "---"}</td>
                  {/* <td>{order?.createdAt || "---"}</td> */}
                  <td>{dateFormatWithTime(order?.createdAt) || '---'}</td>
                  <td>
                    {order?.timeLap?.startTime && order?.timeLap?.endTime
                      ? formatDuration(
                        new Date(order.timeLap.endTime) - new Date(order.timeLap.startTime)
                      )
                      : '---'}
                  </td>
                  <td>{order.request_form?.concern || '---'}</td>
                  <td>{order?.status?.toLowerCase() === 'completed' ? (order?.userTotalConsultationCount != null ? order.userTotalConsultationCount : '---') : '--'}</td>
                  <td>{order?.status?.toLowerCase() === 'completed' ? (order?.consultationOrderLabel || '---') : '--'}</td>
                  <td>{(order?.onCompletion?.consultantAmount != null ? order.onCompletion.consultantAmount.toFixed(2) : "---")}</td>
                     {/* <td>{order?.onCompletion?.platformAmount.toFixed(2) || '---'}</td> */}
                       {/* <td>{order?.onCompletion?.baseAmount.toFixed(2) || "---"}</td> */}
                  <td>{order?.used_for || "---"}</td>
                  <td>
                    {order?.refund ? (
                      <div style={{ fontSize: '12px' }}>
                        <div style={{ color: '#F44336', fontWeight: 'bold' }}>
                          {order.refund.coins?.toFixed(2) || '0.00'}
                        </div>
                       
                      </div>
                    ) : (
                      "---"
                    )}
                  </td>

                  <td>
                    {order?.status === "completed" && (order?.threadId || getConsultationRecordingUrl(order)) ? (
                      <IconButton
                        aria-label="update"
                        className="px-2 py-0"
                      >
                        <VisibilityIcon
                          className="eye_icon"
                          onClick={() => {
                            const recordingUrl = getConsultationRecordingUrl(order);
                            if (!order?.threadId && !recordingUrl) {
                              console.warn("Thread ID and recording URL are missing in this order:", order);
                              return;
                            }

                            setSelectedUserName(`${order?.request_form?.firstName} ${order?.request_form?.lastName}`);
                            setSelectedThreadId(order?.threadId || null);
                            setUserId(order?.user_id);
                            setSelectedRecordingUrl(recordingUrl);
                            setSelectedOrderId(order?.orderId || "");
                            setSelectedConsultationMode(order?.session_info?.mode || "");
                            setShowChatBox(true);
                          }}
                        />
                      </IconButton>
                    ) : (
                      "-----"
                    )}
                  </td>

                  <td>
                    <IconButton
                      aria-label="view-logs"
                      className="px-2 py-0"
                      onClick={() => handleShowLogs(order?.logs)}
                    >
                      <HistoryIcon
                        className="eye_icon"
                        style={{ color: order?.logs && order.logs.length > 0 ? '#ff8989' : '#ccc' }}
                      />
                    </IconButton>
                  </td>

                  <td>
                    {order?.status === "completed" && 
                    !order?.onCompletion?.isAmountRefunded &&
                      order?.onCompletion?.baseAmount !== order?.onCompletion?.refundDetail?.refundAmount &&
                     !FREE_COUPON_CODE.includes(order?.coupon?.code) ? (
                      <button
                        className="btn_size"
                        onClick={() => handleRefundClick(order)}
                        style={{ 
                          fontSize: '12px', 
                          padding: '6px 12px',
                          backgroundColor: '#ffc107',
                          color: '#212529',
                          border: 'none',
                          borderRadius: '4px',
                          cursor: 'pointer',
                          fontWeight: '500',
                          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                          transition: 'all 0.2s ease'
                        }}
                        onMouseOver={(e) => {
                          e.target.style.backgroundColor = '#e0a800';
                          e.target.style.transform = 'translateY(-1px)';
                        }}
                        onMouseOut={(e) => {
                          e.target.style.backgroundColor = '#ffc107';
                          e.target.style.transform = 'translateY(0)';
                        }}
                      >
                        💰 Refund
                      </button>
                    ) : order?.onCompletion?.isAmountRefunded ? (
                      <span style={{ 
                        color: '#F44336', 
                        fontSize: '12px',
                        fontWeight: '600',
                        backgroundColor: '#ffebee',
                        padding: '4px 8px',
                        borderRadius: '4px',
                        border: '1px solid #ffcdd2'
                      }}>
                        ✅ Refunded
                      </span>
                    ) : (
                      "---"
                    )}
                  </td>
                
                  <td>{order?.status || "---"}</td>

                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="15">No Order Found!</td>
              </tr>
            )}
          </tbody>
        </table>
        </div>
        {total > pageLimit ? (
          <div
            className="pagination-wrapper mt-3 d-flex justify-content-end"
            style={{
              flexShrink: 0,
              position: 'sticky',
              bottom: 0,
              right: 0,
              padding: '12px 0',
              backgroundColor: '#fff',
              zIndex: 10,
              boxShadow: '0 -2px 8px rgba(0,0,0,0.06)',
            }}
          >
            <div className="Pagination">
              <Pagination
                activePage={activePage}
                previousLabel={"previous"}
                nextLabel={"next"}
                itemsCountPerPage={pageLimit}
                totalItemsCount={total}
                pageRangeDisplayed={10}
                onChange={handlePageChange}
                hideDisabled={true}
              />
            </div>
          </div>
        ) : null}
      </div>
    </>
  );
};
export default ConsultantHistory;



